export var SUB_TEXT_TESTID = 'SUB_TEXT_';
export var TOGGLE_TESTID = 'TOGGLE';
export var TNC_SLIDER_TESTID = 'TNC_SLIDER';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/modules/TermsAndConditions/constants.js
// module id = 4716
// module chunks = 11